var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0,19v5H5L19.74,9.25l-5-5Zm3.89,2.33H2.67V20.1L14.74,8,16,9.25ZM23.61,3.51,20.49.39A1.31,1.31,0,0,0,19.54,0a1.29,1.29,0,0,0-.93.39L16.17,2.83l5,5,2.44-2.44A1.33,1.33,0,0,0,23.61,3.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3dcebb568c665da03f9e0bd6d94359e7.svg";
export { ForwardRef as ReactComponent };